import React from 'react'
import { Form, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap'
import classNames from 'classnames'
import { ReactComponent as SampleIcon } from '../../../assets/images/sample-icon.svg'
import { ReactComponent as SampleAddedIcon } from '../../../assets/images/sample-added-icon.svg'

import { Button } from '../../../components/Button/Button'
import './Templates.scss'

export interface TemplateChatInputBarProps {
  value: string
  onChange: (value: string) => void
  onSend: () => void
  onKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void
  addedSample: string
  onAddSampleClick: () => void
  onRemoveSample: () => void
  isLoading: boolean
  disabled?: boolean
  placeholder?: string
  className?: string
  sendIconDirection?: 'up' | 'right'
}

export const TemplateChatInputBar: React.FC<TemplateChatInputBarProps> = ({
  value,
  onChange,
  onSend,
  onKeyDown,
  addedSample,
  onAddSampleClick,
  onRemoveSample,
  isLoading,
  disabled = false,
  placeholder = 'Type a message...',
  className,
  sendIconDirection = 'up',
}) => {
  const isDisabled = isLoading || disabled

  return (
    <div className={classNames('d-flex flex-column border rounded-4', className)}>
      <div className='px-4 pt-3 pb-2'>
        <Form.Control
          as='textarea'
          className='border-0 paragraph-medium zocks-text-gray-900 p-0 template-chat-textarea'
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={onKeyDown}
          disabled={isDisabled}
          rows={1}
        />
      </div>
      <hr className='my-0 zocks-border-color-gray-200' />
      <div className='d-flex align-items-center justify-content-between px-4 py-2'>
        <div className='d-flex align-items-center gap-2'>
          {addedSample ? (
            <div className='d-flex align-items-center gap-1'>
              <Button
                variant='lightPurple'
                className='d-flex align-items-center gap-1 rounded-3 py-1 px-2 button-small fw-bold template-ai-chat-sample-added-btn'
                onClick={onAddSampleClick}
                disabled={isDisabled}
              >
                <SampleAddedIcon width={16} height={16} />
                Sample added
                <OverlayTrigger placement='top' overlay={<Tooltip>Remove sample</Tooltip>}>
                  <Button
                    className='d-flex align-items-center justify-content-center p-0 ms-1 template-sample-remove-btn'
                    onClick={(e) => {
                      e.stopPropagation()
                      onRemoveSample()
                    }}
                    disabled={isDisabled}
                  >
                    <i className='bi bi-x-lg' />
                  </Button>
                </OverlayTrigger>
              </Button>
            </div>
          ) : (
            <Button
              variant='darkGhost'
              className='d-flex align-items-center gap-1 rounded-3 py-1 px-2 button-small fw-bold template-add-sample-btn'
              onClick={onAddSampleClick}
              disabled={isDisabled}
            >
              <SampleIcon width={16} height={16} />
              Add a sample
            </Button>
          )}
        </div>
        <Button
          className='d-flex align-items-center justify-content-center bg-black border-0 rounded-circle p-2 template-chat-send-btn'
          onClick={onSend}
          disabled={!value.trim() || isDisabled}
        >
          {isLoading ? (
            <Spinner size='sm' className='text-white template-chat-send-btn' />
          ) : (
            <i className={`bi bi-arrow-${sendIconDirection} text-white template-chat-send-icon`} />
          )}
        </Button>
      </div>
    </div>
  )
}
